import styles from "./gartner-free-trial-modal.styles.module.scss";
import { TypographyComponent } from "../../../../gravity/typography/typography.component";
import { t } from "i18next";
import { FreeTrialBaseModal } from "../gartner-free-trial-base-modal/gartner-free-trial-base-modal.component";
import { FreeTrialRole } from "../more-information-modals.constant";

type GartnerFreeTrialModalProps = {
  open: boolean;
  onClose: () => void;
  onCTAClick: () => void;
  freeTrialDaysRemaining: number;
  freeTrialRole: `${FreeTrialRole}`;
};

export const GartnerFreeTrialModal = ({
  open,
  onClose,
  onCTAClick,
  freeTrialDaysRemaining = 0,
  freeTrialRole= FreeTrialRole.FREE_TRIAL_GUEST,
}: GartnerFreeTrialModalProps) => {
  const daysRemainingText = {
    [FreeTrialRole.FREE_TRIAL_RECIPIENT]: `${t("Your free trial will end in")} ${freeTrialDaysRemaining} ${t("days.")} `,
    [FreeTrialRole.FREE_TRIAL_GUEST]: `${t("The free trial associated with this evaluation will end in")} ${freeTrialDaysRemaining} ${t("days.")} `,
  }[freeTrialRole];

  const expirationText = {
    [FreeTrialRole.FREE_TRIAL_RECIPIENT]: t("When your trial expires, any data in BuySmart will no longer be accessible to you or team members you have invited to an evaluation."),
    [FreeTrialRole.FREE_TRIAL_GUEST]: t("When the trial expires, this evaluation will no longer be accessible."),
  }[freeTrialRole];

  const contactText = {
    [FreeTrialRole.FREE_TRIAL_RECIPIENT]: t("To extend your trial or to inquire about purchasing a Gartner license, please contact your Gartner Account Executive."),
    [FreeTrialRole.FREE_TRIAL_GUEST]: t("The team member who created this evaluation can extend their trial or inquire about purchasing a Gartner license by contacting their Gartner Account Executive."),
  }[freeTrialRole];

  return (
    <FreeTrialBaseModal
      open={open}
      onClose={onClose}
      onCTAClick={onCTAClick}
      title={t("Gartner BuySmart Free Trial")}
      actionButtonText={t("Got It")}
    >
      <div>
        <TypographyComponent styling={"p-default"} boldness={"medium"} rootClassName={styles.paragraph}>
          {daysRemainingText}
          <TypographyComponent styling={"p-default"} boldness={"regular"} element={"span"}>
            {expirationText}
          </TypographyComponent>
        </TypographyComponent>
        <TypographyComponent styling={"p-default"} boldness={"regular"} rootClassName={styles.paragraph}>
          {contactText}
        </TypographyComponent>
        <TypographyComponent styling={"p-default"} boldness={"regular"} rootClassName={styles.paragraph}>
          {t("Full access to BuySmart includes:")}
        </TypographyComponent>
        <ul className={styles.bulletList}>
          <li>
            <TypographyComponent styling={"p-default"} boldness={"regular"} rootClassName={styles.bulletItem}>
              {t("Creation of up to 100 evaluations")}
            </TypographyComponent>
          </li>
          <li>
            <TypographyComponent styling={"p-default"} boldness={"regular"} rootClassName={styles.bulletItem}>
              {t("Export of requirements, questionnaires, scorecards, and more")}
            </TypographyComponent>
          </li>
          <li>
            <TypographyComponent styling={"p-default"} boldness={"regular"} rootClassName={styles.bulletItem}>
              {t("Questionnaire functionality")}
            </TypographyComponent>
          </li>
        </ul>
      </div>
    </FreeTrialBaseModal>
  );
};